let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4nUJ1")).then(() => parcelRequire('1zqfm'));